<template>
  <div class="tab-partners">
    <n-divide class="table-tools">
      <div></div>
      <n-button @click="() => this.$var('add', true)">Создать подряд</n-button>
    </n-divide>

    <n-table :data="data" :columns="columns" :loading="$var('load')">
      <template #avatar="{item}">
        <n-image class="avatar" :src="item.avatar" :mock="!item.avatar" centered alt="avatar" round />
      </template>
      <template #company="{item}">
        {{ item.title }} <span style="opacity: .8;font-size: .8em">[{{ item.bin }}]</span>
      </template>
      <template #roles="{item}">
        <div v-for="role in item.roles" :key="role.id">{{ role.title }}</div>
      </template>
      <template #createdAt="{item}">
        {{ $app.date.format(item.createdAt) }}
      </template>
      <template #info="{item}">
        <n-button icon="eye" @click="$var('edit', item)" />
      </template>
    </n-table>

    <modal-add v-if="$var('add')" :project="project" @submit="add" @close="$var('add', false)" />
    <modal-edit v-if="$var('edit')" :company="$var('edit')" :project="project" :submit="load" @close="$var('edit', false)" />
  </div>
</template>

<script>
import ModalAdd from './modals/ModalAdd'
import ModalEdit from './modals/ModalEdit'

export default {
  name: 'TabPartners',
  components: { ModalAdd, ModalEdit, },
  props: [ 'project', 'my', ],
  data() {
    return {
      showAll: true,
      data: [],
      columns: [
        { name: 'avatar', title: '', },
        { name: 'company', title: 'Компания', },
        { name: 'roles', title: 'Роли', },
        { name: 'createdAt', title: 'Дата назначения', },
        { name: 'info', title: 'Контракты', },
      ],
    }
  },
  watch: {
    showAll() {
      this.$nextTick(() => {
        this.load()
      })
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      const api = $api.iq.partners.get(this.project.id).with({ roles: null, }).query({ projectId: this.project.id, })
      if (this.my) {
        api.filter({ delegator: $app.store.getter('app.company').id, })
      }
      api.then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    add(company) {
      this.$var('edit', company)
      setTimeout(() => {
        this.load()
      }, 1000)
    },
  },
}
</script>

<style lang="scss" scoped>
  .tab-partners {
    .avatar {
      width: 50px;
      height: 50px;
    }
  }
</style>
